window.onload = function() {

    // BACK TO TOP
    jQuery('#backToTop').css('display','none');
    jQuery(window).scroll(function(){
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#backToTop').fadeIn('slow');
        } else {
            jQuery('#backToTop').fadeOut('slow');
        }
    });
    jQuery('#backToTop').click(function(){
        jQuery("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });


    jQuery(function () {
        jQuery('[data-toggle="popover"]').popover();
    });

};


